import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'

import Input from './Input'
import Select from '../../elements/Select'
import '../../../styles/scss/filters/range.scss';

const Range = ({ inputLabel, min, max, range, setMin, setMinSelect, setMax, setMaxSelect }) => {
  const circle_diameter = 50;
  const min_percent = ((min - 1) * 100) / range;
  const max_percent = (max * 100) / range;
  const shift = (percent) => {
    return (percent / 100) * circle_diameter;
  };
  const slider = useRef(null);
  const movingLeft = useRef(false);
  const movingRight = useRef(false);

  useEffect(() => {
    window.addEventListener('mouseup', () => {
      movingLeft.current = movingRight.current = false;
    });
  }, []);


  function onMove(e, isTouchEvent) {
    if (!movingLeft.current && !movingRight.current) return;
    const clientX = isTouchEvent ? _.get(e, 'changedTouches[0].clientX') : e.clientX
    const cx = clientX - slider.current.getBoundingClientRect().left;
    const days = Math.round(
      (cx / slider.current.getBoundingClientRect().width) * range
    );
    if (movingLeft.current) {
      if (days < max) {
        setMin(days + 1);
      }
    }
    if (movingRight.current) {
      if (days > min) {
        setMax(days);
      }
    }
  }

  return (
    <div className="range" aria-label="Date Range">
      <div className="slider-wrapper" aria-valuemin="0">
      <Input
          className="range-desktop-input"
          onChange={setMin}
          label={inputLabel}
          value={min}
        />
        <Select
          className="range-mobile-select"
          onChange={event => setMinSelect(parseInt(event.target.value, 10))}
          options={_.map(new Array(max), (val, index) => ({
            value: index + 1,
            displayName: `${index + 1}${inputLabel ? ` ${inputLabel}` : ''}`
          }))}
          style={{ paddingLeft: inputLabel ? 12 : 56}}
          value={min}
        />
        <div
          ref={slider}
          className="slider"
          onMouseMove={onMove}
          onTouchMove={event => onMove(event, true)}
        >
          <div
            className={'filler'}
            style={{
              left: `calc(${min_percent}% - ${
                shift(min_percent) - circle_diameter / 2
              }px)`,
              right: `calc(${100 - max_percent}% + ${
                shift(max_percent) - circle_diameter / 2
              }px)`,
            }}
          />
          <div
            onMouseDown={(e) => {
              movingLeft.current = true;
            }}
            onTouchStart={(e) => {
              movingLeft.current = true;
            }}
            onTouchEnd={(e) => {
              movingLeft.current = false;
            }}
            style={{
              width: circle_diameter,
              height: circle_diameter,
              left: `calc(${min_percent}% - ${shift(min_percent)}px)`,
            }}
            className="draggable"
          >
            {min}
          </div>
          <div
            onMouseDown={(e) => {
              movingRight.current = true;
            }}
            onTouchStart={(e) => {
              movingRight.current = true;
            }}
            onTouchEnd={(e) => {
              movingRight.current = false;
            }}
            style={{
              width: circle_diameter,
              height: circle_diameter,
              left: `calc(${max_percent}% - ${shift(max_percent)}px)`,
            }}
            className="draggable"
            aria-valuemax="20"
          >
            {max}
          </div>
        </div>
        <Input
          className="range-desktop-input"
          onChange={setMax}
          label={inputLabel}
          value={max}
        />
        <Select
          className="range-mobile-select"
          onChange={event => setMaxSelect(parseInt(event.target.value, 10))}
          options={_.map(new Array(range - (min -1)), (val, index) => ({
            value: index + min,
            displayName: `${index + min}${inputLabel ? ` ${inputLabel}` : ''}`
          }))}
          style={{ paddingLeft: inputLabel ? 12 : 56}}
          value={max}
        />
      </div>
      <div className="footer-range">
        <label>Minimum</label>
        <label>Maximum</label>
      </div>
    </div>
  );
};

Range.propTypes = {
  inputLabel: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  range: PropTypes.number,
  setMin: PropTypes.func,
  setMax: PropTypes.func,
};

export default Range;
